$shm_projects_task_chat $shm_projects_goal_chat
	refresh? 0
